import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { adminApi } from '../api/adminApi';
import { Order, OrderStatus } from '../api/orderApi';

export default function AdminPage() {
  const [orders, setOrders] = useState<Order[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        console.log(user);
        if (!isAuthenticated || user?.role !== 'Admin') {
          navigate('/login');
          return;
        }
        
        const response = await adminApi.getAllOrders();
        if (response.success && response.data) {
          setOrders(response.data);
        } else {
          setError(response.message || 'Ошибка при загрузке заказов');
        }
      } catch (err) {
        setError('Ошибка при загрузке заказов');
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [isAuthenticated, user, navigate]);

  const handleStatusChange = async (orderId: number, newStatus: OrderStatus) => {
    try {
      const response = await adminApi.updateOrderStatus(orderId, newStatus);
      if (response.success && response.data) {
        setOrders(orders.map(order => 
          order.id === orderId ? { ...order, status: newStatus } : order
        ));
      }
    } catch (error) {
      console.error('Ошибка при обновлении статуса заказа:', error);
    }
  };

  if (loading) {
    return <div className="text-gray-300 mt-12">Загружаем информацию...</div>;
  }

  if (error) {
    return <div className="text-red-500">{error}</div>;
  }

  return (
    <div className="flex w-0 flex-1 flex-col gap-6 py-10">      
      <div className="space-y-6">
        {orders.map((order) => (
          <div key={order.id} className="bg-white rounded-lg shadow p-6">
            <div className="flex justify-between items-center mb-4">
              <div>
                <h2 className="text-lg font-medium mt-0">Заказ #{order.id}</h2>
                <p className="text-xs text-gray-500">
                  от {new Date(order.created).toLocaleDateString('ru-RU')}
                </p>
                <p className="text-sm text-gray-500">
                  Клиент: {order.fio} ({order.phone})
                </p>
              </div>
              <div className="text-right">
                <p className="text-lg font-medium">Итого: {order.totalPrice} ₽</p>
                <select
                  value={order.status}
                  onChange={(e) => handleStatusChange(order.id, e.target.value as OrderStatus)}
                  className="mt-2 block w-full rounded-md border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500"
                >
                  <option value={OrderStatus.New}>Новый</option>
                  <option value={OrderStatus.Processing}>В обработке</option>
                  <option value={OrderStatus.Shipped}>Отправлен</option>
                  <option value={OrderStatus.Delivered}>Доставлен</option>
                  <option value={OrderStatus.Cancelled}>Отменен</option>
                </select>
              </div>
            </div>

            <div className="border-t pt-4">
              <h3 className="text-sm font-medium mb-2">Товары:</h3>
              <div className="space-y-2">
                {order.items.map((item) => (
                  <div key={item.id} className="text-sm flex justify-between">
                    <span className="pr-2">{item.brand} {item.name} ({item.code})</span>
                    <span>
                      {item.count} × {item.pricePerUnit} ₽ = {item.totalPrice} ₽
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
} 